import * as React from 'react'
import invariant from 'tiny-invariant'
import { getCookie, setCookie } from 'utils/dom'

const NEXT_PUBLIC_LAST_PROD_COOKIE_NAME = process.env.NEXT_PUBLIC_LAST_PROD_COOKIE_NAME

invariant(
  NEXT_PUBLIC_LAST_PROD_COOKIE_NAME,
  'Missing NEXT_PUBLIC_LAST_PROD_COOKIE_NAME inside /apps/web/hooks/use-last-viewed-prod-set-cookie.ts',
)

export function useLastViewedProdSetCookie(productId: string) {
  React.useEffect(() => {
    function cb() {
      if (document.visibilityState === 'visible') {
        try {
          setCookie({
            name: NEXT_PUBLIC_LAST_PROD_COOKIE_NAME || 'last_viewed_product',
            value: productId ?? 'unknown',
          })
        } catch (error) {
          // eslint-disable-next-line no-console
          console.error(error)
        }
      }
    }
    // We want to run this whenever a users navigates to a PDP or refocuses an already open PDP
    cb()
    document.addEventListener('visibilitychange', cb)
    return () => {
      document.removeEventListener('visibilitychange', cb)
    }
  }, [productId])
}

export function useLastViewedProdGetCookie() {
  const lastViewedProd = React.useMemo(() => {
    const cookieValue = getCookie(NEXT_PUBLIC_LAST_PROD_COOKIE_NAME || 'last_viewed_product')
    return cookieValue === 'unknown' ? undefined : cookieValue
  }, [])

  return lastViewedProd
}
